import { html } from 'uhtml';
import ToggleMenu from '../../00-basics/expandy/expandy.wsutogglemenu';

function SubmenuToggleButton(baseId, fallbackText) {
  return html.node`
    <span id="${`${baseId}-toggle`}" class="menu__toggle button--toggle button--menu">
      <span class="collapsed-only">
        <i class="fas fa-caret-down"></i>
        <span class="visually-hidden">Open submenu</span>
      </span>
      <span class="expanded-only">
        <i class="fas fa-times"></i>
        <span class="visually-hidden">Close submenu</span>
      </span>
      <span class="visually-hidden">
        : ${fallbackText}
      </span>
    </span>
  `;
}

function CollapsibleSubmenu(item) {
  if (!item.querySelector('ul') || item.classList.contains('menu__subhead')) {
    return;
  }

  const itemLink = item.querySelector(':scope > .ml__a');
  const toggleButton = SubmenuToggleButton(item.id, itemLink.textContent);
  item.insertBefore(toggleButton, item.children[1] || null);

  item.querySelectorAll(':scope > ul').forEach((submenu) => {
    const hasActiveTrail = item.querySelector('.active-trail');

    submenu.dataset.menustate = hasActiveTrail ? 'open' : 'closed';
    submenu.setAttribute('aria-labelledby', toggleButton.id);
    submenu.setAttribute('id', `${item.id}-menu`);

    ToggleMenu(submenu, {
      closeOnOutsideClick: false,
      closeOnEscape: false,
    });
  });

  if (itemLink.tagName === 'SPAN') {
    itemLink.addEventListener('click', () =>
      item.querySelector(':scope > button').click(),
    );
  }
}

export default CollapsibleSubmenu;
